const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

import $ from 'jquery';
import './../Categories/Common/checkout.js';


export function	ccAvenue(params)
{
		var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
		
		var data1={access_code:'AVIJ67DJ41BD20JIDB',merchant_id:'103328',order_id:params.order_id,merchant_param1:params.pre_payment_id,merchant_param2:params.deal_type,merchant_param3:params.cart_add_id,merchant_param4:'desktop_web',amount:params.paid_amt,currency:'INR',cancel_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',redirect_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',billing_name:params.username,billing_address:params.address,billing_city:params.city,billing_state:params.state,billing_zip:params.pincode,billing_tel:params.mobile,billing_country:'India',billing_email:params.email};
	 	// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};

		$.ajax({
		method:'POST',
		data:data1,
		url:basePayUrl,
		success:function(response)
		{
		 		$(''+self.state.pageId+'').html(response);
		 		if(response.status==='error' && response.message==='Token mismatch')
		 		{
		 			//data.props.tokenCheck();
		 		}
		},
		error:function(err)
		{
		}
		});
}

export function razorpayForm(params){
        const orders_data = {
	    	receipt:params.order_id,
    		//amount: 1*100, // 2000 rupees in paise
    		amount: params.paid_amt*100, // 2000 rupees in paise
    		currency: 'INR',
    		payment_capture : 0 
        }

			var data1= {from:params.from,orders_data:orders_data};
		    var data2= JSON.stringify(data1);
		    $.ajax({
	      		method:'POST',
	      		dataType:'json',
	      		url:baseUrl+'paymentHandlerWeb',
	      		data:{req:data2},
	      		success:function(response)
	      		{
	      			var rzp_order_id = response.razorpay_order_id;
	      			razorpay(rzp_order_id,params);
	      		},
	      		error:function(err)
	      		{
	      		}
      		});
}

function razorpay(rzp_order_id,params){
  		console.log(params);
		const options = {
    	key: params.rzp_key,
      	amount: params.paid_amt*100,
      	name: params.username,
      	description: params.order_id,
      	order_id: rzp_order_id,
      	//billing_email:this.state.user_details.email,
      handler(response) {
        const paymentId = response.razorpay_payment_id;
        const orderId = response.razorpay_order_id;
        const signature = response.razorpay_signature;

			var data1= {from:params.from,orders_data:options,razorpay_order_id:orderId,razorpay_payment_id:paymentId,razorpay_signature:signature};
		    var data2= JSON.stringify(data1);
		    $.ajax({
	      		method:'POST',
	      		url:baseUrl+'rzpVerifySignature',
	      		data:{req:data2},
	      		success:function(response)
	      		{
	      			$(''+params.pageId+'').html(response);
	      		},
	      		error:function(err)
	      		{
	      		}
      		});




        // const url = process.env.URL+'/api/v1/rzp_capture/'+paymentId+'/'+payment_amount;
        // Using my server endpoints to capture the payment
      },    "modal": {
        ondismiss(response){
			var data1= {from:params.from,razorpay_order_id:rzp_order_id,razorpay_payment_id:''};
		    var data2= JSON.stringify(data1);
		    $.ajax({
	      		method:'POST',
	      		url:baseUrl+'rzpVerifySignature',
	      		data:{req:data2},
	      		success:function(response)
	      		{
	      			if(response != 1){
	      				$(''+params.pageId+'').html(response);	      				
	      			}
	      			//$('.web_checkout_page').html(data);
	      		}.bind(response),
	      		error:function(err)
	      		{
	      		}
      		});    		

        }
    },

  		    prefill: {
  		      name: params.username,
  		      email: (params.email) ? params.email  : '',
  		      contact: params.mobile
  		    },
  		    notes: {
  		      order_id:params.order_id,
  		      merchant_param1:params.pre_payment_id,
  		      merchant_param2:params.deal_type,
  		      merchant_param3:params.cart_add_id,
  		      merchant_param4:params.from,
  		      amount:params.paid_amt,
  		      billing_name:params.username,
  		      billing_address:params.address,
  		      billing_city:params.city,
  		      billing_state:params.state,
  		      billing_zip:params.pincode,
  		      billing_tel:params.mobile,
  		      billing_country:'India',
  		      billing_email:params.email
  		    },  external: {
  		  			wallets: ['paytm','amazonpay'],
  		  			handler: function(data) {
  		    			 'data'
  		   			 if(data.wallet == 'paytm'){
  		   			 	paytmGatewayHandler(params);
  		   			 }
  		   			 if(data.wallet == 'amazonpay'){
  		   			   //console.log(this, data);
  		   			 }
  		  		}
  		}
    };

    	const rzp1 = new window.Razorpay(options);
    	rzp1.open();


}

function paytmGatewayHandler(params){
		    var email = (params.email) ? params.email  : '';
			var data1= {from:params.from,ORDER_ID:params.order_id,INDUSTRY_TYPE_ID:'Retail',CHANNEL_ID:'WEB',TXN_AMOUNT:params.paid_amt,MOBILE:params.mobile,EMAIL: email,CUST_ID:params.uid,merchant_param1: params.pre_payment_id,merchant_param2:params.deal_type,merchant_param3:params.cart_add_id,merchant_param4:params.from};
		    var data2= JSON.stringify(data1);
		    $.ajax({
	      		method:'POST',
	      		url:baseUrl+'paytmPaymentRequestHandler',
	      		data:{req:data2},
	      		success:function(data)
	      		{
	      			//console.log(data);
	      			$('html').html(data);
	      		},
	      		error:function(err)
	      		{
	      		}
      		});
}


/** WEBPACK FOOTER **
 ** ./src/components/functions/custom_functions.js
 **/